'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var transformStyleProperties = ['transform', 'WebkitTransform', 'MozTransform', 'OTransform', 'MSTransform'];
exports.default = transformStyleProperties;